import Section from '@pelckmans/elementis/components/section';
import List from '@pelckmans/elementis/components/list';
import { useTranslation } from 'react-i18next';
import { isScorableMedialink, Medialink } from '../../../../../api/medialink';
import MedialinkListItem from '../MedialinkListItem';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../../constants/analyticsEvents';

interface Props {
  medialinks: Medialink[];
  getMedialinksForExerciseCategory: () => Promise<void>;
}

function MedialinksSection({ medialinks, getMedialinksForExerciseCategory }: Props) {
  const { t } = useTranslation();

  return (
    <Section title={t('PAGES.VEM.MATERIAL_SECTION.TITLE')} emptyMessage={t('PAGES.VEM.MATERIAL_SECTION.EMPTY.TEXT')}>
      {medialinks.length > 0 && (
        <List>
          {medialinks.map(m => (
            <MedialinkListItem
              key={m.id}
              medialink={m}
              onCloseCallback={getMedialinksForExerciseCategory}
              scorable={isScorableMedialink(m)}
              subLocationId={ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_VIRTUAL_EXERCISE_MODULE_EXERCISE_MATERIAL}
            />
          ))}
        </List>
      )}
    </Section>
  );
}

export default MedialinksSection;
